import { z } from 'zod';
// =========================================================
// Registro manual de coladas (autocargables Fiori, sin dosificador/CSV).
//
// `receta_texto` es el mismo concepto que la receta Blend de texto libre
// (`hor.recetas_blend.nombre_texto`, límite NVARCHAR(50)) — el chofer anota
// algo genérico (ej. "Colado Muros") y luego se homologa a un producto BC
// desde `/admin/mapeo-recetas`, igual que las recetas Blend.
// =========================================================
export const CrearColadaManualRequestSchema = z.object({
    id_planta: z.number().int().positive(),
    /** Fecha del colado (YYYY-MM-DD). */
    fecha: z.string().trim().min(1),
    /** Obra o centro de costo, texto libre (mismo rol que `destino_raw`). */
    destino_raw: z.string().trim().min(1).max(255),
    /** Tipo de concreto, texto libre — se homologa después a un producto BC. */
    receta_texto: z.string().trim().min(1).max(50),
    m3_producidos: z.number().positive(),
    id_actividad: z.number().int().positive().nullable().optional(),
    observaciones: z.string().trim().max(2000).nullable().optional(),
});
/**
 * Corrección de los m³ de una colada manual (Fiori) ya registrada. Solo
 * tiene sentido acá: en las coladas Blend el m³ lo calcula el agrupador
 * desde los batches del CSV, nunca se edita a mano.
 */
export const ActualizarM3ColadaManualRequestSchema = z.object({
    m3_producidos: z.number().positive(),
});
//# sourceMappingURL=colada-manual.js.map